import { render, staticRenderFns } from "./userMessage.vue?vue&type=template&id=65a294c8&scoped=true&"
import script from "./userMessage.vue?vue&type=script&lang=js&"
export * from "./userMessage.vue?vue&type=script&lang=js&"
import style0 from "./userMessage.vue?vue&type=style&index=0&id=65a294c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a294c8",
  null
  
)

export default component.exports